<template>
  <div class="component1">
    <a-card :title="$t('问题处置')" :bordered="false" style="margin-bottom: 10px">
      <div class="list1">
        <div class="item0">{{ $t('报警') }}</div>
        <div v-for="item in list1" :key="item.id" class="item1" :style="{backgroundColor: item.bgcolor, color: item.color}">
            <div>{{item.num}}</div>
            <div>{{ $t(item.name) }}</div>
        </div>
      </div>
    </a-card>
    <a-card :title="$t('基础信息')" :bordered="false" style="margin-bottom: 10px;">
      <div>
        <div class="list2">
          <div class="item2" v-for="item in list2" :key="item.id">
            <div class="item2-icon">
                <a-icon :type="item.icon" theme="twoTone" style="font-size: 20px;" />
            </div>
            <div class="item2-content">
                {{ $t(item.title) }}
                <span class="item2-num">{{item.num}}</span>
                {{ $t(item.unit) }}
            </div>
          </div>
        </div>
      </div>
    </a-card>
    <a-card :title="$t('设备数量')" :bordered="false" style="margin-bottom: 10px;">
      <div id="chart" style="height: 240px;width: 100%;"></div>
    </a-card>
  </div>
</template>
        
    <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import Vue from 'vue'
import *as echarts from 'echarts'
export default {
  name: 'modal',
  components: {
  },
  data() {
    return {
      title: this.$t('组件0'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      url: {},
      list1: [
        {
            num: 0,
            name: '待处理',
            bgcolor: '#ECE7E4',
            color: '#EA9C57'
        },
        {
            num: 0,
            name: '已确认',
            bgcolor: '#E9F7EA',
            color: '#7EB279'
        },
        {
            num: 0,
            name: '已派单',
            bgcolor: '#E6E9F0',
            color: '#7696B5'
        },
      ],
      list2: [
        {
            icon: 'appstore',
            title: this.$t('一级分区'),
            num: 6,
            unit: '个',
        },
        {
            icon: 'credit-card',
            title: this.$t('分区面积'),
            num: 0,
            unit: 'km³',
        },
        {
            icon: 'layout',
            title: this.$t('二级分区'),
            num: 0,
            unit: '个',
        },
        {
            icon: 'build',
            title: this.$t('管网长度'),
            num: 0,
            unit: 'km',
        },
        {
            icon: 'home',
            title: this.$t('小区'),
            num: 0,
            unit: '个',
        },
        {
            icon: 'skin',
            title: this.$t('用户数量'),
            num: 0,
            unit: '户',
        },
      ]
    }
  },
  created() {},
  mounted() {
    this.setChart();
  },
  methods: {
    setChart(){
        var chart = echarts.init(document.getElementById('chart'));
        var option;
        option = {
          title: {},
          tooltip: {},
          legend: {
            // 放在右侧垂直显示
            orient: 'vertical',
            right: 10,
            top: 'center'
          },
          series: [{
            type: 'pie',
            radius: ['30%', '50%'],
            center: ['35%', '50%'],
            data: [
              {value: 0, name: this.$t('分区进出水')},
              {value: 0, name: this.$t('流量监测点')},
              {value: 0, name: this.$t('压力监测点')},
              {value: 0, name: this.$t('水质监测点')},
              {value: 0, name: this.$t('远传大用户')},
            ]
          }]
        }
        chart.setOption(option);
        window.addEventListener('resize', function () {
          chart.resize();
        });
    }
  },
}
</script>
<style lang="less" scoped>
.component1{
    width: 400px;
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 999;
}
.list1{
    display: flex;
    justify-content: space-between;
    .item0{
        width: 24%;
        height: 60px;
        background-color: #F16361;
        border-radius: 4px;
        padding: 10px;
        color: #fff;
        font-size: 20px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .item1{
        width: 24%;
        height: 60px;
        background-color: #f5f5f5;
        border-radius: 4px;
        padding: 10px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}
.list2{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item2{
        width: 49%;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item2-icon{
            width: 40px;
            height: 40px;
            background-color: #EFF0F2;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .item2-content{
            font-size: 14px;
            color: #333333;
            .item2-num{
                display: inline-block;
                margin: 0 5px;
                font-size: 18px;
                font-color: #000;
                font-weight: 600;
            }
        }
    }
}
::v-deep .ant-card{
    border-radius: 8px;
    box-shadow: 2px 3px 4px;
}
::v-deep .ant-card-body{
    padding: 10px;
}
::v-deep .ant-card-head{
    min-height: auto;
    padding: 0 10px;
}
::v-deep .ant-card-head-title{
    padding: 10px 0;
}
::v-deep .ant-card-head-title::before{
    content: '';
    display: inline-block;
    width: 3px;
    height: 12px;
    border-radius: 4px;
    background-color: #1890FF;
    margin-right: 5px;
}
</style>